/**
 * API エンドポイント設定
 */
// 開発環境のみ localhost フォールバックを使用
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? 'http://localhost:8080' : '');

/**
 * バックエンド OAuth エンドポイント
 *
 * OAuth フローはすべてバックエンドで処理される:
 * 1. フロントエンド → /auth/raksul（OAuth 開始）
 * 2. バックエンド → OAuth プロバイダー（認可）
 * 3. OAuth プロバイダー → /auth/raksul/callback（コールバック）
 * 4. バックエンド → フロントエンド（JWT Cookie 設定済み）
 *
 * Client ID/Secret はバックエンドで管理（環境変数または Secret Manager）
 */
export const BACKEND_AUTH_ENDPOINTS = {
  // OAuth 認可フロー開始（バックエンドが OAuth プロバイダーにリダイレクト）
  // OAuth エンドポイントはバージョニングしない（/api/v1 配下ではない）
  authorize: `${API_BASE_URL}/auth/raksul`,
  // ログアウト
  logout: `${API_BASE_URL}/api/v1/auth/logout`,
  // ユーザー情報取得
  me: `${API_BASE_URL}/api/v1/auth/me`,
} as const;

/**
 * 認証エラーメッセージ
 */
export const AUTH_ERROR_MESSAGES = {
  serverError: 'サーバーエラーが発生しました。しばらくしてからお試しください。',
  networkError: 'ネットワークエラーが発生しました。接続を確認してください。',
  invalidState: '不正なリクエストです。もう一度ログインしてください。',
  unauthorized: '認証に失敗しました。もう一度お試しください。',
  authFailed: '認証に失敗しました。もう一度お試しください。',
} as const;
